import { ButtonHTMLAttributes, FC } from 'react';

import { MoonLoader } from 'react-spinners';

import { Container, ButtonText } from './styles';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean;
  buttonDisable?: boolean;
};

const Button: FC<ButtonProps> = ({
  children,
  loading,
  buttonDisable,
  ...rest
}) => (
  <Container
    type="button"
    disabled={buttonDisable}
    buttonDisable={buttonDisable}
    {...rest}
  >
    {loading ? (
      <MoonLoader size={30} color="#000000" />
    ) : (
      <ButtonText>{children}</ButtonText>
    )}
  </Container>
);

export default Button;
